<template>
  <!-- 报名详情--未通过 -->
  <div class="passedExam">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入姓名"
          style="width: 200px"
          @keyup.enter.native="tableLoad"
          @clear="
            query.query = '';
            tableLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="tableLoad"
            >查询</el-button
          >
        </Debounce>
        <el-select
          v-model="query.provinceId"
          filterable
          @change="proChange"
          placeholder="请选择"
        >
          <el-option label="全部省份" value=""></el-option>
          <el-option
            v-for="item in proList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.examSiteId"
          @change="examChange"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部市代" value=""></el-option>
          <el-option
            v-for="item in examSitList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.registerId"
          @change="tableLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部考点" value=""></el-option>
          <el-option
            v-for="item in rationSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <Debounce>
        <el-button
          type="danger"
          v-if="$roleFilter('apply:server:batch:delete')"
          size="small"
          @click="cancelInfo"
          >删除</el-button
        >
      </Debounce>
      <Debounce>
        <el-button
          type="primary"
          v-if="$roleFilter('apply:server:batch:pass')"
          size="small"
          @click="operatInfo(1)"
          >通过</el-button
        >
      </Debounce>
      <Debounce>
        <el-button
          type="danger"
          v-if="$roleFilter('apply:server:batch:no')"
          size="small"
          @click="operatInfo(0)"
          >不通过</el-button
        >
      </Debounce>
      <Debounce>
        <el-button size="small" @click="exportExcel">导出</el-button>
      </Debounce>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%;"
      @sort-change="sortChange"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      @selection-change="handleSelectionChange"
      :height="$store.getters.getTableHeight - 50"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        prop="name"
        fixed="left"
        label="考生照片"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.photo"
            style="height:30px;"
            @click="operatInfo(5, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        fixed="left"
        label="姓名"
        sortable="custom"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="surName"
        fixed="left"
        label="姓氏拼音"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="englishName"
        fixed="left"
        label="名字拼音"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column width="50" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="birth"
        label="出生日期"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="age"
        width="50"
        label="年龄"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="countryName"
        label="国籍"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="idNumber"
        label="证件号码"
        width="170"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="联系电话"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="快递地址"
        width="200"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省份"
        width="70"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examSiteName"
        label="市级代理"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="registrationPointName"
        show-overflow-tooltip
        label="考点"
        align="center"
      ></el-table-column>
      <el-table-column label="报考等级" fixed="right" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.testLevel | getLvTextByLv }}
        </template>
      </el-table-column>
      <el-table-column
        prop="zdjs"
        show-overflow-tooltip
        label="指导教师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="zdjsdh"
        show-overflow-tooltip
        label="指导教师电话"
        align="center"
      ></el-table-column>
      <el-table-column label="上传证书" fixed="right" width="80" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.certificate"
            type="text"
            size="small"
            @click="certificate(scope.row)"
            >查看证书</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog
      custom-class="dailogComponents"
      title="不通过"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="360px"
    >
      <div class="dialogBox">
        <div class="contentBox">
          <p>是否不通过所选报名?</p>
          <p><span style="color:red">*</span>请输入不通过原因:</p>
          <el-input
            v-model="comment"
            type="textarea"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit"
              >确认</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";
export default {
  props: ["infoId"],
  data() {
    return {
      tableList: [],
      tableSelectList: [],
      proList: [], //省份考点下拉菜单
      rationSiteList: [], //报考等级下拉
      examSitList: [], //考点下拉菜单
      tableIsLoad: true,
      visible: false,
      comment: "",
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        auditStatus: 2, //报名状态 1:已通过 2：待审核 0：未通过
        examInformationId: "", //考试信息ID
        examSiteId: "", //所属市级代理
        provinceId: "", //所属省份ID
        testLevel: "", //报考等级
        registerId: "", //报名点id
        orderByChineseMethod: null, //姓名排序
        orderByChineseField: null, //姓名排序
      },
    };
  },
  created() {
    this.query.examInformationId = this.infoId;
  },
  mounted() {
    if (this.infoId == null) {
      return;
    }
    this.tableLoad();
    this.getSelectList();
  },
  methods: {
    //列表排序改变事件
    sortChange(column) {
      if (column != null && column.order != null) {
        this.query.orderByMethod =
          column.order === "ascending" ? "asc" : "desc";
        this.query.orderByField =
          column.prop === "idNumber" ? "id_number" : column.prop;
        console.log(column);
        if (column.prop === "name") {
          this.query.orderByMethod = null;
          this.query.orderByField = null;
          this.query.orderByChineseMethod =
            column.order === "ascending"
              ? "asc"
              : column.order === "ascending"
              ? "descending"
              : "desc";
          this.query.orderByChineseField = column.prop;
        } else {
          this.query.orderByChineseMethod = null;
          this.query.orderByChineseField = null;
        }
      } else {
        this.query.orderByMethod = null;
        this.query.orderByField = null;
        this.query.orderByChineseMethod = null;
        this.query.orderByChineseField = null;
      }
      this.tableLoad();
    },
    //导出
    exportExcel() {
      this.$axios
        .post("/apply/export", this.query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
        });
    },
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post("/apply/details/list", this.query).then((res) => {
        console.log(res);
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.$nextTick((item) => {
          this.$refs.elTable.doLayout();
        });
        this.tableIsLoad = false;
      });
    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get("/apply/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/apply/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get("/apply/rationSite").then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
    },
    getRegList() {
      this.$axios
        .get(`/process/register/${this.query.examSiteId}`)
        .then((res) => {
          let data = res.data.data;
          this.rationSiteList = data;
        });
    },
    handleSelectionChange(val) {
      this.tableSelectList = val;
    },
    cancelInfo() {
      //通过
      if (this.tableSelectList.length === 0) {
        this.$message({
          type: "warning",
          message: "请选择数据进行操作!",
          duration: 1000,
        });
        return;
      }
      let submitIdList = this.tableSelectList.map((item) => {
        return item.id;
      });
      this.$dailog({
        title: "取消报名",
        context: "是否取消报名已选中的考生信息?",
        callbackFun: () => {
          this.$axios.put("/apply/cancels", submitIdList).then((res) => {
            this.$message({
              type: "success",
              message: "取消成功!",
              duration: 1000,
            });
            this.tableLoad();
          });
        },
      });
    },
    operatInfo(type, row) {
      if (type == 1) {
        //通过
        if (this.tableSelectList.length === 0) {
          this.$message({
            type: "warning",
            message: "请选择数据进行操作!",
            duration: 1000,
          });
          return;
        }
        let submitIdList = this.tableSelectList.map((item) => {
          return item.id;
        });
        this.$dailog({
          title: "通过",
          context: "是否通过所有已选报名?",
          callbackFun: () => {
            this.$axios
              .put("/apply/batch/review", {
                ids: submitIdList,
                status: 1,
              })
              .then((res) => {
                this.$message({
                  type: "success",
                  message: "通过成功!",
                  duration: 1000,
                });
                this.tableLoad();
              });
          },
        });
      } else if (type == 5) {
        this.$alert(
          `<img src="${row.photo}" style="width:100%;max-height:700px;" />`,
          "图片查看",
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: true,
          }
        );
      } else {
        if (this.tableSelectList.length === 0) {
          this.$message({
            type: "warning",
            message: "请选择数据进行操作!",
            duration: 1000,
          });
          return;
        }
        this.visible = true;
      }
      //不通过
    },
    certificate(row) {
      window.open(row.certificate);
    },
    proChange(val) {
      // this.query.examSiteId = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.provinceId === val;
      //   });
      //   this.examSitList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    examChange(val) {
      // this.rationSiteList = [];
      // this.query.registerId = "";
      // if (val) {
      //   this.getRegList();
      // }
      this.tableLoad();
    },
    submit() {
      //不通过
      if (this.comment == "") {
        this.$message({
          type: "warning",
          message: "不通过的意见不可为空!",
          duration: 1000,
        });
        return;
      }
      let submitIdList = this.tableSelectList.map((item) => {
        return item.id;
      });
      this.$axios
        .put("/apply/batch/review", {
          ids: submitIdList,
          status: 0,
          comment: this.comment,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功!",
            duration: 1000,
          });
          this.comment = "";
          this.tableLoad();
          this.visible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tableHearInputBox {
  .el-select {
    width: 200px;
    margin-right: 10px;
  }
}

.contentBox {
  padding: 0px 20px 10px 20px;

  p {
    line-height: 1.5;
  }
}

.dialogBox {
  p {
    margin-bottom: 5px;
  }
}

.spanStyle {
  color: #f56c6c;
  text-decoration: underline;
}
</style>
